// ### Imports
// * Import lib
import React from "react";
import { useNavigate } from "react-router";
// * Import 3rd party lib
import { Box, Button, styled, Typography, useTheme } from "@mui/material";

const GoToButton = styled(Button)(({ theme }) => ({
  width: theme.size[280],
  borderRadius: theme.size[15],
  height: theme.size[35],
  boxShadow: theme.boxShadow,
  border: `${theme.size[1]} solid ${theme.palette.button.background}`,
  backgroundColor: theme.palette.button.background,
  zIndex: "1000",
  color: theme.palette.button.text,
  fontSize: theme.size[13],
  textTransform: "none",
  "&:hover": {
    backgroundColor: theme.palette.button.background,
    color: theme.palette.button.text,
  },
  "&:disabled": {
    opacity: "0.5",
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[900],
    border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
  },
}));

function PageNotFound() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        textAlign: "center",
        margin: theme.margin[2],
        fontWeight: theme.fontWeight[600],
      }}
    >
      <Typography sx={{ fontSize: theme.size[24], fontWeight: 500 }}>
        Page Not Found
      </Typography>
      <br></br>
      <GoToButton
        onClick={() => {
          navigate("/discover");
        }}
      >
        Go to Explore
      </GoToButton>
    </Box>
  );
}

export default PageNotFound;
